import { render } from "./InfoBeranda.vue?vue&type=template&id=5d042749"
import script from "./InfoBeranda.vue?vue&type=script&lang=js"
export * from "./InfoBeranda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__